const { databaseServer } = require('../config/network');

const getAssetsByCollectionId = async (token, collectionId) => {
    return fetch(`${databaseServer}/collections/${collectionId}/assets`, {
        headers: new Headers({
            'Authorization': token
        })
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const getAssetsById = async (token, id) => {
    return fetch(`${databaseServer}/assets/${id}`,{
        headers: new Headers({
            'Authorization': token
        })})
        .then(response => response.json() )
        .catch(error => console.log(error));
}


const createAsset = async (token, asset) => {

    return fetch(`${databaseServer}/assets`, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify(asset),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const editAssetOnDb = async (token, asset) => {
    return fetch(`${databaseServer}/assets/${asset.id}`, {
        method: 'put',
        mode: 'cors',
        body: JSON.stringify(asset),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const deleteAssetFromDb = async (token, id) => {
    return fetch(`${databaseServer}/assets/${id}`, {
        method: 'delete',
        mode: 'cors',
        headers: new Headers({
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const getSerialNumbers = async (token, id) => {
    return fetch(`${databaseServer}/assets/serialnumbers`,{
        headers: new Headers({
            'Authorization': token
        })})
        .then(response => response.json() )
        .catch(error => console.log(error));
}

module.exports = {
    getAssetsByCollectionId,
    getAssetsById,
    createAsset,
    deleteAssetFromDb,
    editAssetOnDb,
    getSerialNumbers,
}